import { BaseApiClient } from '../client'
import type { Campaign, CreateCampaignInput, UpdateCampaignInput } from '../types'

export class CampaignsApi extends BaseApiClient {
  async list() {
    return this.request<Campaign[]>('/api/admin/campaigns')
  }

  async get(id: string) {
    return this.request<Campaign>(`/api/admin/campaigns/${id}`)
  }

  async create(data: CreateCampaignInput) {
    return this.request<Campaign>('/api/admin/campaigns', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  async update(id: string, data: UpdateCampaignInput) {
    return this.request<Campaign>(`/api/admin/campaigns/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    })
  }

  async forceSync(id: string) {
    return this.request<{ success: boolean; message: string }>(`/api/admin/campaigns/${id}/sync`, {
      method: 'POST',
    })
  }
}
